import * as Contract from '../../SharedApiExternalContract';
import { DashboardObjectType, ExtensionDashboardInfo, SheetPath, VisualId } from '@tableau/api-internal-contract-js';

import { DashboardObject } from '../DashboardObject';
import { InternalToExternalEnumMappings } from '../EnumMappings/InternalToExternalEnumMappings';
import { Point } from '../Point';
import { Size } from '../Size';
import { Worksheet } from '../Worksheet';

import { SheetImpl } from './SheetImpl';
import { SheetInfoImpl } from './SheetInfoImpl';
import { WorksheetImpl } from './WorksheetImpl';

import { ErrorHelpers } from '../Utils/ErrorHelpers';

export class DashboardImpl extends SheetImpl {
  private _worksheets: Array<Contract.Worksheet>;
  private _objects: Array<Contract.DashboardObject>;

  public constructor(private _info: ExtensionDashboardInfo, private _sheetPath: SheetPath) {
    super(new SheetInfoImpl(_info.name, Contract.SheetType.Dashboard, new Size(_info.size.h, _info.size.w)));
  }

  public get worksheets(): Array<Contract.Worksheet> {
    return this._worksheets;
  }

  public get objects(): Array<Contract.DashboardObject> {
    return this._objects;
  }

  public initializeWithPublicInterfaces(dashboard: Contract.Dashboard): void {
    ErrorHelpers.verifyInternalValue(dashboard, 'dashboard');

    this._worksheets = new Array<Worksheet>();
    this._objects = new Array<Contract.DashboardObject>();

    // Process all the zones which are contained in this dashboard
    for (const zone of this._info.zones) {
      let worksheet: Worksheet | undefined = undefined;

      const zoneSize = new Size(zone.height, zone.width);

      if (zone.zoneType === DashboardObjectType.Worksheet) {
        const sheetInfo = new SheetInfoImpl(zone.name, Contract.SheetType.Worksheet, zoneSize);
        const vizId: VisualId = {
          worksheet: zone.name,
          dashboard: this._info.name,
          storyboard: this._sheetPath.storyboard,
          flipboardZoneID: this._sheetPath.flipboardZoneID,
          storyPointID: this._sheetPath.storyPointID
        };

        const worksheetImpl = new WorksheetImpl(sheetInfo, vizId, dashboard);
        worksheet = new Worksheet(worksheetImpl);
        this._worksheets.push(worksheet);
      }

      const zonePoint = new Point(zone.x, zone.y);

      const dashboardObject = new DashboardObject(
        dashboard,
        InternalToExternalEnumMappings.dashboardObjectType.convert(zone.zoneType),
        zonePoint,
        zoneSize,
        worksheet
      );

      this._objects.push(dashboardObject);
    }
  }
}



// WEBPACK FOOTER //
// ../../../../src/ApiShared/Impl/DashboardImpl.ts


// WEBPACK FOOTER //
// webpack:///src/ApiShared/Impl/DashboardImpl.ts